// src/App.tsx
import React from "react";
import { Link, Route, Routes, useLocation, useNavigate } from "react-router-dom";

import Home from "./pages/Home";
import About from "./pages/About";
import Interview from "./pages/Interview";
import InactiveNotice from "./pages/Inactive";
import AssessmentsList from "./pages/AssessmentsList";
import AssessmentNew from "./pages/AssessmentNew";
import AssessmentEdit from "./pages/AssessmentEdit";
import AssessmentInterview from "./pages/Assessment";
import { RequireAuth, useAuth } from "./AuthProvider";
import { LoginPage } from "./pages/Login";

function App() {
    const { isAuthenticated, isLoading, email, activated, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const onLoginPage = location.pathname === "/login";

    if (isLoading) {
        return <div style={{ color: "white" }}>Checking login…</div>;
    }

    // 🚫 Logged in but not activated
    if (isAuthenticated && activated === false) {
        return <InactiveNotice />;
    }

    return (
        <div className="min-h-screen bg-bg text-text font-sans">
            <nav className="mb-6 px-6 pt-6 flex items-center justify-between">
                <div className="flex items-center gap-4">
                    <Link to="/" className="text-accent hover:underline">Home</Link>
                    <Link to="/about" className="text-accent hover:underline">About</Link>

                    {isAuthenticated && (
                        <>
                            <Link to="/interview" className="text-accent hover:underline">
                                Interview
                            </Link>
                            <Link to="/assessments" className="text-accent hover:underline">
                                Assessments
                            </Link>
                        </>
                    )}
                </div>

                <div>
                    {isAuthenticated ? (
                        <div className="flex items-center gap-3 text-sm text-text/80">
                            {email && <span className="hidden sm:inline">{email}</span>}

                            <button
                                onClick={logout}
                                className="rounded-md border border-border px-3 py-1.5 text-text hover:bg-header transition"
                            >
                                Log out
                            </button>
                        </div>
                    ) : !onLoginPage ? (
                        <button
                            onClick={() => navigate("/login")}
                            className="rounded-md bg-accent px-4 py-1.5 text-sm text-black hover:bg-accentHover transition"
                        >
                            Log in
                        </button>
                    ) : (
                        <div />
                    )}
                </div>
            </nav>

            <main className="px-6 pb-10">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/login" element={<LoginPage />} />

                    <Route element={<RequireAuth />}>
                        <Route path="/about" element={<About />} />
                        <Route path="/interview" element={<Interview />} />
                        <Route path="/assessments" element={<AssessmentsList />} />
                        <Route path="/assessments/new" element={<AssessmentNew />} />
                        <Route path="/assessments/:id/edit" element={<AssessmentEdit />} />
                        <Route path="/assessments/:id/interview" element={<AssessmentInterview />} />
                    </Route>
                </Routes>
            </main>
        </div>
    );
}

export default App;
